import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import { allowedPositions } from '@/modules/base/components/texts/config'

const TextBlock = ({ children, position, className }) => {
  const classes = useStyles()
  return (<p className={clsx(classes.root, classes[position], className)}>{children}</p>)
}

const useStyles = makeStyles(() => {
  return {
    root: {
      marginBottom: '25px',
    },
    left: { textAlign: 'left' },
    center: { textAlign: 'center' },
    right: { textAlign: 'right' },
  }
})

TextBlock.propTypes = {
  position: PropTypes.oneOf(allowedPositions),
  className: PropTypes.string,
}

TextBlock.defaultProps = {
  position: 'left',
}

export default TextBlock
